export default RAILS_ASSET_URL("/gallery-image-10.webp")
